module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reg-tea2nd"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.error) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.error))])])]) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _c('div', {
    staticClass: "reg-tea2nd-beehive"
  }, [_c('BeeHive', {
    attrs: {
      "lstItems": _vm.grades
    },
    on: {
      "onlstItems": _vm.onlstGrades
    }
  })], 1), _c('div', {
    staticClass: "reg-tea2nd-beehive-mobile"
  }, [_c('BeeHiveMobile', {
    attrs: {
      "lstItemsMobile": _vm.grades
    },
    on: {
      "onlstItemsMobile": _vm.onlstGrades
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _c('div', {
    staticClass: "reg-tea2nd-beehive"
  }, [_c('BeeHive', {
    attrs: {
      "lstItems": _vm.subjects
    },
    on: {
      "onlstItems": _vm.onlstSubjects
    }
  })], 1), _c('div', {
    staticClass: "reg-tea2nd-beehive-mobile"
  }, [_c('BeeHiveMobile', {
    attrs: {
      "lstItemsMobile": _vm.subjects
    },
    on: {
      "onlstItemsMobile": _vm.onlstSubjects
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group custom-form-group"
  }, [_c('div', {
    staticClass: "col-md-12 reg-tea2nd-title"
  }, [_c('p', [_vm._v("Yêu cầu tạo môn học mới (nếu có)")]), _c('selectize', {
    attrs: {
      "settings": _vm.settings
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Yoga online")]), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Erobic")])])], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group custom-form-group",
    class: _vm.errorArray
  }, [_vm._m(2), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-images"
  }, [_vm._l((_vm.lstImages), function(img, index) {
    return (img) ? _c('div', {
      staticClass: "box-item"
    }, [_c('span', {
      staticClass: "material-icons",
      on: {
        "click": function($event) {
          return _vm.removeImg(index)
        }
      }
    }, [_vm._v("cancel")]), _c('img', {
      attrs: {
        "src": img.src
      }
    })]) : _vm._e()
  }), _c('div', {
    staticClass: "box-item last"
  }, [_c('input', {
    attrs: {
      "name": "files[]",
      "type": "file",
      "multiple": "multiple",
      "accept": "image/x-png,image/jpeg"
    },
    on: {
      "change": _vm.previewDegrees
    }
  }), _vm._m(3)])], 2)])])]), _c('div', {
    staticClass: "row"
  }, [(_vm.socialType === 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.siteKey
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  })], 1) : _vm._e()]), _vm._m(4), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 lo-custom-footer"
  }, [_c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "reg-tea2nd-btn-validate btn",
    on: {
      "click": _vm.validateRegister
    }
  }, [_vm._v("Đăng ký")])])]), _c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "reg-tea2nd-btn-cancel btn",
    on: {
      "click": _vm.backLogin
    }
  }, [_vm._v("Quay lại")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 reg-tea2nd-title"
  }, [_c('p', [_vm._v("Bạn có thể dạy các khối lớp nào?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 reg-tea2nd-title"
  }, [_c('p', [_vm._v("Các môn học bạn có thể giảng dạy?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "reg-tea2nd-title"
  }, [_vm._v("Hình ảnh bằng cấp/ chứng chỉ của bạn *")]), _c('p', {
    staticClass: "reg-tea2nd-title-upload"
  }, [_vm._v("Vui lòng cung cấp hình ảnh rõ nét, không mờ, không lóa để quá trình xác thực được diễn ra nhanh chóng. Các hình ảnh cần có Ảnh chụp văn bằng/ chứng chỉ có liên quan đến công việc giảng dạy của bạn.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "material-icons list-action"
  }, [_vm._v("add")]), _c('strong', [_vm._v("Tải ảnh lên")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "reg-tea2nd-context"
  }, [_vm._v("- Tôi hoàn toàn chịu trách nhiệm về các thông tin đã khai báo trên")]), _c('p', {
    staticClass: "reg-tea2nd-context"
  }, [_vm._v("- Yêu cầu sau khi được gửi phải được admin phê duyệt")]), _c('p', {
    staticClass: "reg-tea2nd-context"
  }, [_vm._v("- Bằng cách chọn \"Đăng ký\" bạn đồng ý với "), _c('span', [_vm._v("Điều khoản sử dụng cho giáo viên")]), _vm._v(" và "), _c('span', [_vm._v("Chính sách bảo mật dành cho giáo viên")]), _vm._v(" của chúng tôi.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62791a76","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/itemRegisterTeacher2.vue
// module id = 1585
// module chunks = 0